import React from 'react';
import { Link } from 'react-router-dom';
import { CornerDecoration } from '@components/common';
import '@styles/placeholder.css';
import './GamesPage.css';

const GamesPage: React.FC = () => {
  return (
    <section className="page-section placeholder-section">
      <div className="placeholder-container">
        <h1 className="placeholder-title">Games</h1>

        <div className="placeholder-icon">
          <span className="icon-symbol">🕹️</span>
        </div>

        <p className="placeholder-description">
          Our game library is being curated.
          Prepare for an epic collection of digital adventures.
        </p>

        <div className="cloud-archive-card">
          <h2 className="cloud-archive-card__title">
            <span className="cloud-archive-card__icon">☁️</span>
            Cloud Archive Available
          </h2>
          <p className="cloud-archive-card__description">
            While we're building our local archive, you can access our complete
            game collection through the cloud storage.
          </p>
          <p className="cloud-archive-card__warning">
            Note: The cloud archive may load slowly as it contains over 1.3 million games.
            Please be patient while browsing.
          </p>
          <a
            href="https://mega.nz/folder/57UggRJI#2Jqw1A_pzU4WgjZS6vi35w"
            target="_blank"
            rel="noopener noreferrer"
            className="cloud-archive-card__link"
          >
            Open MEGA Archive
          </a>
          <p className="cloud-archive-card__stats">
            1,300,000+ games available
          </p>
        </div>

        <nav className="nav-links">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/consoles" className="nav-link">Consoles</Link>
          <Link to="/donate" className="nav-link">Donate</Link>
        </nav>
      </div>

      <CornerDecoration />
    </section>
  );
};

export default GamesPage;
